import { GET_TICKETS, GET_TICKETS_ERROR, GET_TICKETS_REQUEST, UPDATE_TICKETS_DATA, REMOVE_TICKETS_DATA, GET_TICKET_TYPE, GET_TICKET_TYPE_ERROR, GET_TICKET_TYPE_REQUEST, UPDATE_TICKET_TYPE_DATA, REMOVE_TICKET_TYPE_DATA } from "../ActionTypes/ActionTypes.js";

const initialState = {
    ticketLoading: false,
    ticketData: null,
    ticketError: null,
    ticketStatus: null,
    isModified: false,
    ticketTypeLoading: false,
    ticketTypeData: null,
    ticketTypeError: null,
    ticketTypeStatus: null,
    isTicketTypeModified: false,


};

const supportReducer = (state = initialState, action) => {
    switch (action.type) {

        case GET_TICKETS_REQUEST:
            return { ...state, ticketLoading: state?.isModified === true ? false : true, ticketStatus: null, ticketData: Array.isArray(state?.ticketData) ? [...state.ticketData] : [] };
        case GET_TICKETS:
            return { ticketLoading: false, ticketData: action.payload, ticketError: null, ticketStatus: true };
        case GET_TICKETS_ERROR:
            return { ticketLoading: false, ticketData: null, ticketError: action?.payload, ticketStatus: false };
        case UPDATE_TICKETS_DATA:
            const updatedTicket = action.payload;
            return {
                ...state,
                ticketData: {
                    ...state.ticketData,
                    result: state.ticketData?.result?.details?.map((ticket) =>
                        ticket.ticketId === updatedTicket.ticketId
                            ? {
                                ...ticket,
                                ...updatedTicket
                            }
                            : ticket
                    )
                }, ticketError: null, isModified: true
            }
        case REMOVE_TICKETS_DATA:
            return { ...state, ticketData: null, depositTypeError: null, isModified: false, ticketStatus: null }


        case GET_TICKET_TYPE_REQUEST:
            return { ...state, ticketTypeLoading: state?.isTicketTypeModified === true ? false : true, ticketTypeStatus: null, ticketTypeData: [...state?.ticketTypeData || []] };
        case GET_TICKET_TYPE:
            return { ticketTypeLoading: false, ticketTypeData: action.payload, ticketTypeError: null, ticketTypeStatus: true };
        case GET_TICKET_TYPE_ERROR:
            return {
                ticketTypeLoading: false, ticketTypeError: action?.payload, ticketTypeStatus: false, ticketTypeData: null
            };
        case UPDATE_TICKET_TYPE_DATA:
            return {
                ...state, ticketTypeData: {
                    ...state.ticketTypeData,
                    result: {
                        ...state.ticketTypeData.result,
                        ...action.payload,
                    },
                }, ticketTypeError: null, isTicketTypeModified: true
            }
        case REMOVE_TICKET_TYPE_DATA:
            return { ...state, ticketTypeData: null, depositTypeError: null, isTicketTypeModified: false, ticketTypeStatus: null }
        default:
            return state;
    }
};

export default supportReducer;